module.exports = __webpack_public_path__ + "img/Feature-1.08bd10c.svg";